export const TRACKED_OPERATION_KEY = 'opengater.admin.tracked-user-operation';
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
function valid(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        return false;
    const record = value;
    return (Object.keys(record).length === 2 &&
        Number.isSafeInteger(record.userId) &&
        Number(record.userId) > 0 &&
        typeof record.operationId === 'string' &&
        UUID.test(record.operationId));
}
export function saveTrackedOperation(userId, operationId) {
    const value = { userId, operationId };
    if (!valid(value))
        return;
    try {
        localStorage.setItem(TRACKED_OPERATION_KEY, JSON.stringify(value));
    }
    catch {
        // The operation remains visible in the current component even if storage is unavailable.
    }
}
export function readTrackedOperation(userId) {
    try {
        const raw = localStorage.getItem(TRACKED_OPERATION_KEY);
        if (!raw)
            return null;
        const value = JSON.parse(raw);
        return valid(value) && value.userId === userId ? value.operationId : null;
    }
    catch {
        return null;
    }
}
export function clearTrackedOperation(userId) {
    if (readTrackedOperation(userId) == null)
        return;
    try {
        localStorage.removeItem(TRACKED_OPERATION_KEY);
    }
    catch {
        // Nothing else to clean up when storage is unavailable.
    }
}
